import { StyleSheet, Text, TouchableOpacity, Linking, View, useWindowDimensions } from 'react-native'
import React from 'react'
import Ionicons from '@expo/vector-icons/Ionicons';
import { colors } from '../../colors'
import { displayFont } from '../../fonts'

const Footer = () => {
  const window = useWindowDimensions();
  const narrow = window.width < 768;
  const openAppStore = () => Linking.openURL('https://www.facebook.com/ivyoootv');

  return (
    <View style={[styles.container, narrow && styles.containerNarrow, narrow && { backdropFilter: 'blur(18px)', WebkitBackdropFilter: 'blur(18px)' }]}>
      <Text style={styles.text}>Copyright 2022 ivyooo.com | IVYOOO, INC. | Privacy Policy</Text>
      <View style={styles.social}>
        <Text style={styles.textSocial}>Follow us on </Text>
        <TouchableOpacity accessibilityRole="link" accessibilityLabel="Follow iVYOOO on Facebook" onPress={openAppStore} style={styles.button}>
            <Ionicons name="logo-facebook" size={28} color={colors.offwhite} />
        </TouchableOpacity>
      </View>
    </View>
  )
}

export default Footer

const styles = StyleSheet.create({
    container: {
        width: '100%',
        minHeight: 60,
        backgroundColor: 'black',
        paddingLeft: 16,
        paddingRight: 16,
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    containerNarrow: {
        width: 'auto',
        height: 'auto',
        minHeight: 52,
        marginHorizontal: 12,
        marginBottom: 16,
        paddingVertical: 8,
        paddingHorizontal: 14,
        justifyContent: 'space-between',
        backgroundColor: 'rgba(10,10,10,0.22)',
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.18)',
        borderRadius: 18,
    },
    text: {
        color: colors.offwhite,
        fontFamily: displayFont,
        fontSize: 13,
        lineHeight: 18,
        letterSpacing: 0.4,
        flexShrink: 1,
    },
    button: {
        width: 44,
        height: 44,
        marginRight: 8,
        justifyContent: 'center',
        alignItems: 'center',
    },
    social: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    textSocial: {
        color: colors.offwhite,
        fontFamily: displayFont,
        fontSize: 13,
        letterSpacing: 0.4,
        paddingRight: 6,
    }
})